import { default as ReactSelect } from "react-select";
import { FC, useState } from "react";

const options = [
  {
    value: 5,
    label: 5,
  },
  {
    value: 10,
    label: 10,
  },
];

type Props = {
  onSelect: (value: number) => void;
};

type TransactionSizeFilterOption = {
  value: number;
  label: number;
};

const TransactionSizeFilter: FC<Props> = ({ onSelect }) => {
  const [selectedOptions, setSelectedOptions] = useState<TransactionSizeFilterOption[]>([]);

  const handleChange = (selected: any) => {
    console.log("SELECTED TRANSACTION SIZE ", selected);

    setSelectedOptions(selected);

    const value = (selected as TransactionSizeFilterOption)

    onSelect(value.value);
  };

  return (
    <ReactSelect
      options={options}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      onChange={handleChange}
      value={selectedOptions}
      isClearable={false}
    />
  );
};

export default TransactionSizeFilter;
